import React from 'react';
import { Box, Container, Typography, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        background: '#0a192f',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box>
            <IconButton
              href="https://www.linkedin.com/in/melihsah-akin/"
              target="_blank"
              color="primary"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              href="https://github.com/Evasionn"
              target="_blank"
              color="primary"
              aria-label="GitHub"
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              href="https://instagram.com/melihsahakin"
              target="_blank"
              color="primary"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              href="mailto:melihsahakin@gmail.com"
              color="primary"
              aria-label="Email"
            >
              <EmailIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {new Date().getFullYear()} Melihşah Akın. {t('footer.rights')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
